import styled from 'styled-components';
import { secondaryColors } from '@tryhackme/thm-ui-components';

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.main};
  padding: 3rem 1.4rem;
  border-radius: 1rem;
  text-align: center;
  position: relative;
  max-width: 39.5rem;
  background: radial-gradient(96.48% 145.93% at 96.48% 103.66%, #3e475a 0%, #151c2b 55.58%, #151c2b 100%),
    ${secondaryColors.offBlack};

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
    padding: 3rem 5rem;
  }
`;

export const StyledTitle = styled.p`
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
  line-height: 3.2rem;
  margin-bottom: 1.4rem;
`;

export const StyledSubtitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  margin-bottom: 1.6rem;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const StyledTimerMessage = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  margin-bottom: 1.1rem;
`;

export const StyledCrownImage = styled.img`
  position: absolute;
  top: 0;
  right: 0;

  width: 8.215rem;
  transform: translate(21px, -33px) rotate(22.25deg);

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    width: 10.553rem;
    transform: translate(26px, -41px) rotate(22.25deg);
  }
`;
